// src/components/MetricCard.js
import React from 'react';

function MetricCard({ title, value }) {
    return (
        <div className="metric-card">
            <div className="metric-card-title">{title}</div>
            <div className="metric-card-value">{value}</div>
        </div>
    );
}

export default MetricCard;